module.exports = __webpack_public_path__ + "img/krivaya.9824819c.png";